import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useSearchParams} from '@github-ui/use-navigate'
import {useQuery} from '@github-ui/react-query'
import type {ModelsSearchFiltersPayload} from '../types'

const defaultCategories: ModelsSearchFiltersPayload['categories'] = [
  'agents',
  'conversation',
  'large context',
  'low latency',
  'multilingual',
  'multimodal',
  'multipurpose',
  'rag',
  'reasoning',
  'understanding',
]

const defaultPublishers: ModelsSearchFiltersPayload['publishers'] = [
  {name: 'cohere', displayName: 'Cohere'},
  {name: 'core42', displayName: 'Core42'},
  {name: 'deepseek', displayName: 'DeepSeek'},
  {name: 'meta', displayName: 'Meta'},
  {name: 'microsoft', displayName: 'Microsoft'},
  {name: 'mistral-ai', displayName: 'Mistral'},
  {name: 'ai21labs', displayName: 'AI21 Labs'},
  {name: 'openai', displayName: 'Azure OpenAI Service'},
  {name: 'xai', displayName: 'xAI'},
]

/**
 * Load the valid values for searching GitHub Models by its supported filters, such as by publisher or category.
 */
export function useModelsSearchFilters() {
  const [searchParams] = useSearchParams()
  return useQuery<ModelsSearchFiltersPayload>({
    queryKey: ['github-models', 'search-filters'],
    async queryFn() {
      const res = await verifiedFetchJSON('/models/search-filters')
      if (res.ok) return await res.json()
      return {categories: defaultCategories, publishers: defaultPublishers} satisfies ModelsSearchFiltersPayload
    },
    initialData: {categories: defaultCategories, publishers: defaultPublishers},
    enabled: searchParams.get('type') === 'models',
  })
}
